import { render, staticRenderFns } from "./TutorEventCard.vue?vue&type=template&id=303384d5&scoped=true&"
import script from "./TutorEventCard.vue?vue&type=script&lang=js&"
export * from "./TutorEventCard.vue?vue&type=script&lang=js&"
import style0 from "./TutorEventCard.vue?vue&type=style&index=0&id=303384d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303384d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
